import React from 'react';

import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import { Container, Loading, Text } from './styled';
import { IPaymentMethodAddNewItemOptionProps } from './types';

const PaymentMethodAddNewItemOption = ({
  text,
  Icon,
  onClick,
  'data-testid': dataTestId,
  selected = false,
  isLoading = false,
}: IPaymentMethodAddNewItemOptionProps) => {
  const { logEvent } = useMParticleContext();

  const handleOnClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!onClick) {
      return;
    }
    if (!selected) {
      logEvent(CustomEventNames.BUTTON_CLICK, EventTypes.Other, { name: text });
    }
    onClick(e);
  };

  return (
    <Container onClick={handleOnClick} $isClickable={!!onClick} data-testid={dataTestId}>
      {Icon}
      <Text brandFontKey={selected ? 'copyOne' : 'copyTwo'}>{text}</Text>
      {isLoading && <Loading data-testid="method-option-loading-icon" />}
    </Container>
  );
};

export default PaymentMethodAddNewItemOption;
